var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE1IntermediateLevels(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 55V28.8L21 14.28 0 29.11V59h76v-4H42zM21 19.25L36.67 30H5.6L21 19.25zM38 55H4V45h34v10z",
    fill: "#040404"
  })));
}
export default __webpack_public_path__ + "static/media/E1_Intermediate_levels.308c2f65.svg";
export { SvgE1IntermediateLevels as ReactComponent };